import type { AnyRoute } from "@tanstack/react-router";

import { createMessagingRoutes } from "./createMessagingRoutes";
import type { CommunicationsRouteDeps } from "./communicationsRouteContext";

export type {
  CommunicationsRouteDeps,
  CommunicationsRouteFactory,
} from "./communicationsRouteContext";

export function createCommunicationsRoutes(
  deps: CommunicationsRouteDeps,
): AnyRoute[] {
  return [...createMessagingRoutes(deps)];
}
